import React from 'react';

// Hidden trap field for the website forms. People never see it; bots fill it in, and the server then saves nothing.
export const HoneyPot = () => (
  <div className="sc-hp" aria-hidden="true">
    <label>
      Leave this field empty
      <input type="text" name="website" tabIndex={-1} autoComplete="off" />
    </label>
  </div>
);

// Result message under a form. status: 'success' | 'error' (nothing is shown for any other value).
export const FormNote = ({ status, children }) =>
  status === 'success' || status === 'error' ? (
    <p className={`sc-form-note ${status}`} role={status === 'error' ? 'alert' : 'status'}>
      {children}
    </p>
  ) : null;
